import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { routes } from '~/constants';
export class SharedLinkModel {
    static fromDTO(dto) {
        return new SharedLinkModel(dto.notificationId, "https://".concat(window.location.host).concat(routes.notification(dto.notificationId)));
    }
    constructor(notificationId, notificationURL){
        _define_property(this, "notificationId", void 0);
        _define_property(this, "notificationURL", void 0);
        this.notificationId = notificationId;
        this.notificationURL = notificationURL;
    }
}
